import { React } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';

const MemberShipColumn = () => {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <Column width={292} style={{marginLeft: '15px'}}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colMembership')}</Text>
      </Column>
      <Column width={140}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colPeriod')}</Text>
      </Column>
      <Column width={150}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colPayment')}</Text>
      </Column>
      <Column width={176}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colUnpaid')}</Text>
      </Column>
      <Column width={58}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colRemaining')}</Text>
      </Column>
      <Column width={60}>
        <Text fontFmaily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('memberDetail.colSessions')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

export default MemberShipColumn;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  margin: 34px 0px 20px 0px;

  width: 1020px;

  gap: 12px;

  transition: all 0.3s ease-in-out;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;